<template>
  <div>
    <InputRadioGroup
      legend="Betalning av mobilen"
      type-class="product-page"
      column-class="one-column"
    >
      <InputRadioButton
        v-for="payment in store.pricesOptions"
        :id="payment.Time?.toString() ?? '1'"
        :key="payment.DownPayment + payment.Time"
        v-model="store.productState.selectedDownPaymentTime"
        classes="min-h-72 md:min-h-82"
        :value="payment.Time?.toString() ?? '1'"
        :simple-label="false"
        :group-name="`payment-${groupNameId}`"
        @update:model-value="store.changeOption('payment')"
      >
        <template #name-advanced>
          <p class="heading-xs">
            {{ payment.Time !== 1 ? 'Delbetala' : 'Betala direkt' }}
          </p>
          <p class="heading-xxs">
            {{
              payment.Time === 1 ? '' : `${payment.Time?.toString()} månader`
            }}
          </p>
        </template>

        <template #price-advanced>
          <p v-if="payment.Time !== 1" class="heading-xxs text-text-success">
            Räntefritt
          </p>
          <p
            class="heading-xxs flex items-center"
            :aria-label="
              !!payment.RegularDownPayment
                ? `Ordinarie ${payment.RegularDownPayment} ${payment.Time === 1 ? 'kr' : 'kr/mån'}, nu ${payment.DownPayment} ${payment.Time === 1 ? 'kr' : 'kr/mån'}`
                : `${payment.DownPayment} ${payment.Time === 1 ? 'kr' : 'kr/mån'}`
            "
          >
            <span
              v-if="payment.RegularDownPayment"
              class="strike-through text-text-secondary me-8"
              aria-hidden="true"
            >
              {{ `${payment.RegularDownPayment.toLocaleString('sv-SE')}` }}
            </span>
            {{
              `${payment.DownPayment.toLocaleString('sv-SE')} ${payment.Time === 1 ? 'kr' : 'kr/mån'}`
            }}
          </p>
        </template>
      </InputRadioButton>
    </InputRadioGroup>
    <PaymentLogosHorizontal class="mt-16" />
  </div>
</template>

<script lang="ts" setup>
const store = useMyProductPageStore();

const groupNameId = useId();
</script>

<style></style>
